export enum Route {
    CountrySettings = '/country-settings',
    PublicItemsLocker = '/public-items-locker',
    ChainItems = '/public-items-locker/chain/:id',
    Surveys = '/surveys',
    SurveyDetails = '/surveys/:id',
    SurveyAddItems = '/surveys/:id/add-items',
}

export enum RouteParams {
    Id = ':id',
}